import {
    RACING_RACECARD_UPDATE,
    RACING_RACECARD_UPDATE_FROM_CACHE,
    RACING_RACECARD_UPDATE_SELECTION_PRICE,
    RACING_SET_IS_STREAMING,
} from './types';

export const updateRaceCard = (raceCardData, eventId) => ({
    type: RACING_RACECARD_UPDATE,
    raceCardData,
    eventId,
});

export const updateRaceCardFromCache = raceCard => ({
    type: RACING_RACECARD_UPDATE_FROM_CACHE,
    raceCard,
});

export const updatePrice = data => ({
    type: RACING_RACECARD_UPDATE_SELECTION_PRICE,
    data: data.events,
});

export const setStreaming = isStreaming => ({
    type: RACING_SET_IS_STREAMING,
    data: isStreaming,
});
